import { formatDate, getRelativeTime } from '@thoughtspot/date-format-util';
import { useTranslation } from '@thoughtspot/i18n';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import { ElementType, } from '@thoughtspot/radiant-react/widgets/form-builder/interface';
import { getSessionInfo } from '@thoughtspot/session-service';
import React from 'react';
import { getSchedhuledMaintainance } from '../../../services/system/config-service/session-service';
import { Vertical } from '../../../utils/layouts';
import { Header } from '../common';
import styles from './scheduled-maintenance.module.scss';
const DATE_FORMAT_STRING = 'EEEE, d MMMM yyyy, t ZZZZ';
export const ScheduledMaintenance = () => {
    const { t } = useTranslation();
    const initialConfig = {
        type: {
            id: 'type',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.type'),
            },
            value: null,
        },
        description: {
            id: 'description',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.description'),
            },
            value: null,
        },
        startTimestampSecond: {
            id: 'startTimestampSecond',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.startTime'),
            },
            value: null,
        },
        when: {
            id: 'when',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.when'),
            },
            value: null,
        },
        durationSecond: {
            id: 'durationSecond',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.duration'),
            },
            value: null,
        },
        status: {
            id: 'status',
            elementType: ElementType.INPUT,
            config: {
                type: 'text',
                label: t('adminSection.scheduleMaintenance.tableHeader.status'),
            },
            value: null,
        },
    };
    const scheduledMaintenanceValues = getSchedhuledMaintainance();
    const configMapper = (config) => {
        const updatedConfig = Object.keys(config).map(configKey => {
            let value = scheduledMaintenanceValues[configKey] || '--';
            if (configKey === 'startTimestampSecond') {
                const currentSessionInfo = getSessionInfo();
                const timeZoneOffset = new Date().getTimezoneOffset();
                const utcDate = new Date(scheduledMaintenanceValues.startTimestampSecond * 1000 -
                    timeZoneOffset * 60 * 1000);
                const clusterTimezoneDate = utcDate.toLocaleString('en-US', {
                    timeZone: currentSessionInfo.timezone,
                    hour12: false,
                });
                const clusterTimezoneTimestamp = new Date(clusterTimezoneDate).getTime();
                const systemCalendar = true;
                value = formatDate(clusterTimezoneTimestamp, DATE_FORMAT_STRING, systemCalendar);
            }
            else if (configKey === 'durationSecond') {
                const valInMinutes = Math.floor(value / 60);
                value = t('MINUTES_COUNT', { numMinutes: valInMinutes });
            }
            else if (configKey === 'when') {
                value = getRelativeTime(scheduledMaintenanceValues.startTimestampSecond * 1000);
            }
            config[configKey].value = value;
            return config[configKey];
        });
        return updatedConfig;
    };
    const renderViewForm = () => {
        const formFieldConfig = configMapper(initialConfig);
        return (React.createElement("div", { "data-test-id": "scheduleMaintenanace-withState" },
            React.createElement(FormBuilder, { formFields: formFieldConfig, viewMode: "view" })));
    };
    const renderEmptyStateForm = () => {
        const { status } = initialConfig;
        status.value = t('adminSection.system.scheduledmaintenance.notification');
        status.config.isTextValueColorLight = true;
        return (React.createElement("div", { "data-test-id": "scheduleMaintenanace-withoutState" },
            React.createElement(FormBuilder, { formFields: [status], viewMode: "view" })));
    };
    const currentTimestampMilliSecs = new Date().getTime();
    return (React.createElement(Vertical, { className: styles.container },
        React.createElement("div", null,
            React.createElement("div", { className: styles.headerWrapper },
                React.createElement(Header, { title: t('adminSection.system.scheduledmaintenance.name'), titleSize: "large", subTitle: t('adminSection.system.scheduledmaintenance.description'), isFullWidth: true })),
            scheduledMaintenanceValues &&
                currentTimestampMilliSecs <
                    scheduledMaintenanceValues.startTimestampSecond * 1000 +
                        scheduledMaintenanceValues.durationSecond * 1000
                ? renderViewForm()
                : renderEmptyStateForm())));
};
//# sourceMappingURL=scheduled-maintenance.container.js.map